'use strict'

export default process



// WEBPACK FOOTER //
// ./src/config/api.js